// Resolución de tenant por subdominio en el cliente: <slug>.tukipro.com → "slug".
// La raíz (tukipro.com / www), los hosts de Railway y localhost NO tienen tenant
// (→ landing pública). El slug resuelto se manda al backend como X-Org-Slug para
// que sepa qué boliche mostrar en las pantallas públicas. OJO: esto define el
// CONTEXTO PÚBLICO; las acciones de un usuario logueado se atan a su JWT, no a esto.
const BASE_DOMAINS = ['tukipro.com'];

// Slugs reservados: no pueden ser de un boliche. Mantener en sync con el backend.
export const RESERVED_SLUGS = ['www', 'admin', 'api', 'app', 'mail', 'staging', 'tukipro', 'soporte', 'ayuda'];

export function getTenantSlug() {
  if (typeof window === 'undefined') return null;
  const host = (window.location.hostname || '').toLowerCase();
  if (host === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return null;
  for (const base of BASE_DOMAINS) {
    if (host.endsWith('.' + base)) {
      const slug = host.slice(0, -(base.length + 1));
      if (!slug || slug.includes('.')) return null;   // raíz o multinivel → sin tenant
      if (RESERVED_SLUGS.includes(slug)) return null;  // reservado → sin tenant
      return slug;
    }
  }
  return null; // raíz, hosts de Railway, dominios propios sin subdominio, etc.
}

// Header para que el backend resuelva el tenant público a partir del subdominio.
export function orgHeader() {
  const slug = getTenantSlug();
  return slug ? { 'X-Org-Slug': slug } : {};
}

// URL pública del venue por SUBDOMINIO (https://<slug>.tukipro.com) cuando estamos
// en el dominio de plataforma. En hosts sin wildcard (Railway/localhost) cae al path
// viejo /sitio/<slug>, que sigue funcionando. Así los links NUEVOS usan subdominio
// sin romper el entorno de dev/staging.
export function venueUrl(slug) {
  if (!slug) return '/';
  if (typeof window !== 'undefined') {
    const host = (window.location.hostname || '').toLowerCase();
    const base = BASE_DOMAINS.find(b => host === b || host === 'www.' + b || host.endsWith('.' + b));
    if (base) return `${window.location.protocol}//${slug}.${base}`;
  }
  return `/sitio/${slug}`;
}

// ¿Estamos en la raíz de la plataforma (tukipro.com / www)? Ahí va la landing +
// alta de boliches, no la home de un venue. En hosts de Railway/localhost devuelve
// false (mantienen el comportamiento actual hasta que el dominio esté con wildcard).
export function isPlatformRoot() {
  if (typeof window === 'undefined') return false;
  const host = (window.location.hostname || '').toLowerCase();
  return BASE_DOMAINS.includes(host) || BASE_DOMAINS.some(b => host === 'www.' + b);
}
